/** @format */

import Alert from '@mui/material/Alert';
import {Box, LinearProgress, Typography} from '@mui/material';
import {Trans} from 'react-i18next';

import BackHeader from 'components/BackHeader';

import PaymentMethod from './PaymentMethod';
import {useGetCurrentUserQuery} from './graphql/__generated__';

const PaymentMethods = () => {
  const {loading, error, data} = useGetCurrentUserQuery();

  if (error) {
    return <Alert severity='error'>{error.message}</Alert>;
  }
  if (loading || !data?.currentUser?.paymentMethods) {
    return <LinearProgress style={{flex: 1}} />;
  }

  const {paymentMethods} = data.currentUser;

  return (
    <>
      <Box mb={10}>
        <BackHeader />
      </Box>
      <Typography variant='h1'>
        <Trans>Платёжные данные</Trans>
      </Typography>

      <Box mt={7}>
        {paymentMethods.length === 0 ? (
          <Typography variant='body2'>
            <Trans>У вас нет активных карт.</Trans>
          </Typography>
        ) : (
          paymentMethods.map((v, i) => (
            <Box key={i} mb={3}>
              <PaymentMethod paymentMethod={v} variant='DARK' />
            </Box>
          ))
        )}
      </Box>
    </>
  );
};

export default PaymentMethods;
